// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.socket[data-v-a3dd44ce] {\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    border: 1px solid grey;\r\n    /*width: $socket-size;\r\n  height: $socket-size * 2;\r\n  vertical-align: middle;\r\n  */\r\n    background: #fff;\r\n    z-index: 2;\r\n    box-sizing: border-box;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
